import { useState } from "react";
import { CardContent, Typography, Box, Stack, Popper, Fade, ClickAwayListener } from "@mui/material";
//icons
import { GradienSettingsIcon } from '../component/icons/icon-gradient';
//styles
import { CustomCard } from "../styles/style";
import { SettingsIcon } from "lucide-react";
import ServerConfigModal from "../modules/modals/ServerConfigModal";

const CardContainerMainLayout = (props) => {

    const { title, children, isBorder, transform, popup, serverData, selectedServer } = props;


    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [disableClickAway, setDisableClickAway] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    const handleClose = () => {
        if (!disableClickAway) {
            setOpen(false);
        }
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen((previousOpen) => !previousOpen);

        setDisableClickAway(true);
        setTimeout(() => setDisableClickAway(false), 100);
    };

    const handleSettingsClick = () => {
        setModalOpen(true);
    };

    const handleModalClose = () => {
        setModalOpen(false);
    };

    const handleSave = (credentials) => {
        setModalOpen(false);
    };

    const canBeOpen = open && Boolean(anchorEl);
    const id = canBeOpen ? 'transition-popper' : undefined;

    return (
        <CustomCard isBorder={isBorder} transform={transform}>
            <CardContent sx={{ padding: '0px' }}>
                <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'end' }}>
                    <Box>
                        {/* <Box sx={{ padding: '10px' }} onClick={handleClick}>
                            <GradienSettingsIcon />
                        </Box> */}
                        {(serverData?.code === 'huawei' || serverData?.code === 'google_drive' || serverData?.code === 'one_drive') && (
                            <Box sx={{ padding: '10px', cursor: 'pointer', zIndex: 10 }} onClick={(e) => { e.stopPropagation(); handleSettingsClick(); }}>
                                <SettingsIcon />
                            </Box>
                        )}
                        <ClickAwayListener onClickAway={handleClose}>
                            <Popper id={id} open={open} anchorEl={anchorEl} transition placement={'bottom-end'} onClo>
                                {({ TransitionProps }) => (
                                    <Fade {...TransitionProps} timeout={350}>
                                        <Box sx={{
                                            bgcolor: 'background.paper',
                                            margin: '-5px 10px 0px 0px',
                                            borderRadius: '12px',
                                            padding: '5px',
                                            border: '1px solid #e0e0e0',
                                            minHeight: '100px',
                                            minWidth: '150px'
                                        }}>
                                            {popup}
                                        </Box>
                                    </Fade>
                                )}
                            </Popper>
                        </ClickAwayListener>
                    </Box>
                </Box>
                <Stack spacing={1}>
                    <Typography variant="h4">
                        {title}
                    </Typography>
                    <Box>
                        {children}
                    </Box>
                </Stack>
            </CardContent>
            
            <ServerConfigModal 
                open={modalOpen} 
                onClose={handleModalClose} 
                onSave={handleSave} 
                serverCode={serverData}
                selectedServer={selectedServer}
            />
        </CustomCard>
    );
};

export default CardContainerMainLayout;